var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7044 41.569C20.7044 34.6655 26.3009 29.069 33.2044 29.069C40.108 29.069 45.7044 34.6655 45.7044 41.569C45.7044 48.4726 40.108 54.069 33.2044 54.069C26.3009 54.069 20.7044 48.4726 20.7044 41.569ZM33.2044 37.4023C30.9032 37.4023 29.0378 39.2678 29.0378 41.569C29.0378 43.8702 30.9032 45.7357 33.2044 45.7357C35.5056 45.7357 37.3711 43.8702 37.3711 41.569C37.3711 39.2678 35.5056 37.4023 33.2044 37.4023Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16797 12.5H38.7629L51.2629 20.8333H95.8346V87.5H4.16797V12.5ZM12.5013 20.8333V79.1667H23.1515L49.791 52.6652L56.54 58.4501L74.8069 40.1267L87.5013 51.2343V29.1667H48.7397L36.2397 20.8333H12.5013ZM87.5013 62.3074L75.1957 51.54L62.885 63.8887L80.7093 79.1667H87.5013V62.3074ZM67.9044 79.1667L50.2116 64.0014L34.9674 79.1667H67.9044Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderImage);
export default __webpack_public_path__ + "static/media/folder-image.b4e9969d4c800d34c691a7089a55dbb5.svg";
export { ForwardRef as ReactComponent };